<template>
    <div id="app">
        <router-view v-if="inited"/>
    </div>
</template>
<script>
import util from "./utils/util";
  export default {
    data() {
      return {
          inited:false,
      }
    },
    mounted() {

    },
    created() {
        this.$axios.get('api/h5/init').then((res) => {
          util.data.initData= res.data;
          this.inited=true;
        });
    },
  }
</script>
<style>
    html, body {
        height: 100%;
        min-height: 100%;
    }

    #app {
        height: 100%;
    }

    body .el-table th.gutter {
        display: table-cell !important;
    }

    .input-box .el-input__inner {
        text-indent: 20px;
    }

    #Novel_Details .el-cascader__tags {
        display: inline-block !important;
        line-height: 30px !important;
    }
</style>
